import { IObservableValue, observable } from 'mobx';
import { ParticipantPageFilter } from '../modules/Participant/interfaces/participantPageFilter';

class ParticipantStore {
    @observable private pageFilter: IObservableValue<ParticipantPageFilter | null>;

    constructor() {
        this.pageFilter = observable.box(null);
    }

    getPageFilter(): ParticipantPageFilter | null {
        return this.pageFilter.get();
    }

    setPageFilter(value: ParticipantPageFilter | null) {
        this.pageFilter.set(value);
    }
}

const participantStore = new ParticipantStore();

export default participantStore;
export { ParticipantStore };
